import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

const Details = () => {
    const {id}= useParams();
    const [details,setDetails]=useState([])
    useEffect(()=>{
        fetch(`projects.json/${id}`)
        .then(res=>res.json)
        .then(data=>setDetails(data))
    },[])

    return (
        <div>
            <img src={details.name} alt="" />
            <h1>{details.length}</h1>
            <h1>hello</h1>
            
        </div>
    );
};

export default Details;